<template>
  <section id="home_games_left">
    <div class="box">
      <p class="title">
        <span>{{ authStore.user.availableGames }}</span>

        {{ $_translations.value.page_profile_overview_section_game_games_left }}
      </p>

      <BaseButton
        v-if="!appSettingsStore.isStoreDisabled"
        :disabled="authStore.hasUserAvailableGames"
        @click:button="redirectToStorePage"
      >
        {{ $_translations.value.page_profile_overview_section_game_button_games }}
      </BaseButton>
    </div>
  </section>
</template>

<script setup>
import useAppSettingsStore from '@/store/modules/appSettings.js';
import useAuthStore from '@/store/modules/auth.js';
import BaseButton from '@/components/button/BaseButton.vue';
import usePageNavigationHook from '@/hooks/usePageNavigation.js';

const appSettingsStore = useAppSettingsStore();
const authStore = useAuthStore();

const { redirectToStorePage } = usePageNavigationHook();
</script>
